<template>
    <v-snackbar v-model="display" :color="color">
        {{ content }}

        <v-btn @click="display = false" icon>
            <v-icon>mdi-close</v-icon>
        </v-btn>
    </v-snackbar>
</template>

<script>
import { sync, get } from 'vuex-pathify'

export default {
    computed: {
        display: sync('flash/display'),
        color: get('flash/color'),
        content: get('flash/content'),
    }
}
</script>
